import { lazy } from 'react';

export const TourTriggerButtonLazy = lazy(
    () => import('./tour-trigger-button'),
);
